import { apiClient } from '@/lib/api';
import { ApiKey, ApiKeyCreated } from '../types/api-keys.types';

export const apiKeysApi = {
  getAll: async (): Promise<ApiKey[]> => {
    const result = await apiClient.get('/api/keys');
    return result as unknown as ApiKey[];
  },

  create: async (name: string): Promise<ApiKeyCreated> => {
    const result = await apiClient.post('/api/keys', { name });
    return result as unknown as ApiKeyCreated;
  },

  revoke: async (id: string): Promise<void> => {
    await apiClient.delete(`/api/keys/${id}`);
  },
};
